export default __webpack_public_path__ + "static/media/PP2.b4077e14.png";